export default __webpack_public_path__ + "static/media/ico_checkbox_full_blue.3b30e181.svg";